import {z} from "zod/v4-mini"
import {TextureType} from "#material/types/texture"

export const unresolvedTextureSetRevisionSlotSchema = z.object({
    id: z.string(),
    slot: z.nativeEnum(TextureType),
})

export const resolvedTextureSetRevisionSlotSchema = z.object({
    dataObject: z.object({
        id: z.string(),
        legacyId: z.number(),
    }),
    displacementCm: z.optional(z.number()),
    heightCm: z.number(),
    id: z.string(),
    textureType: z.nativeEnum(TextureType),
    widthCm: z.number(),
})
export const textureSetRevisionSlotResolverSchema = z.any()

export type UnresolvedTextureSetRevisionSlot = {
    id: string
    slot: TextureType
}
export type ResolvedTextureSetRevisionSlot = {
    dataObject: {
        id: string
        legacyId: number
    }
    displacementCm?: number
    heightCm: number
    id: string
    textureType: TextureType
    widthCm: number
}
export type TextureSetRevisionSlotResolver = (slot: UnresolvedTextureSetRevisionSlot) => Promise<ResolvedTextureSetRevisionSlot>

export const resolvedTextureSetRevisionSchema = z.object({
    displacementCm: z.optional(z.number()),
    heightCm: z.number(),
    id: z.string(),
    mapAssignments: z.array(z.object({id: z.string(), legacyId: z.number(), textureType: z.nativeEnum(TextureType)})),
    widthCm: z.number(),
})
export const textureSetRevisionResolverSchema = z.any()

export type ResolvedTextureSetRevision = {
    displacementCm?: number
    heightCm: number
    id: string
    mapAssignments: {id: string; legacyId: number; textureType: TextureType}[]
    widthCm: number
}
export type TextureSetRevisionResolver = (textureSetRevisionId: string) => Promise<ResolvedTextureSetRevision>
